import * as React from "react";
const ReplaySearchContext = React.createContext({
  alertId: void 0,
  definitionId: void 0,
  type: void 0
});
export default ReplaySearchContext;
